import React from 'react';
import { Typography, theme } from 'antd';
import IconBadge from './IconBadge';

const { Title, Text } = Typography;
const { useToken } = theme;

// Header estándar de una sección dentro de una página.
// - index: marcador corto tipo "§ 01" o "01" (opcional). Se renderiza en
//   fontFamilyCode, uppercase, color terciario. Por convención, no pasarlo
//   salvo que la página realmente lo necesite (ej. referencias cruzadas).
// - title: string | ReactNode (requerido)
// - subtitle: string | ReactNode
// - icon: componente de @ant-design/icons (opcional)
// - tint: color del icono (default: colorPrimary)
// - actions: ReactNode alineado a la derecha (Button "Agregar", links, etc.)
// - level: 1-5 para Typography.Title (default 4)
function SectionHeader({
  index,
  title,
  subtitle,
  icon,
  tint,
  actions,
  level = 4,
}) {
  const { token } = useToken();
  const resolvedTint = tint ?? token.colorPrimary;

  return (
    <div
      style={{
        marginBottom: token.marginLG,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: token.marginMD,
        flexWrap: 'wrap',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: token.marginSM,
          minWidth: 0,
          flex: 1,
        }}
      >
        {icon && <IconBadge icon={icon} tint={resolvedTint} size="md" />}
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: 10,
              marginBottom: 2,
              flexWrap: 'wrap',
            }}
          >
            {index && (
              <span
                style={{
                  fontFamily: token.fontFamilyCode,
                  fontSize: 11,
                  letterSpacing: '0.12em',
                  color: token.colorTextTertiary,
                  textTransform: 'uppercase',
                }}
              >
                {index}
              </span>
            )}
            <Title level={level} style={{ margin: 0, fontWeight: 600 }}>
              {title}
            </Title>
          </div>
          {subtitle && (
            <Text type="secondary" style={{ fontSize: 13, display: 'block' }}>
              {subtitle}
            </Text>
          )}
        </div>
      </div>
      {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}

export default SectionHeader;
